import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { UsdAmountTooltip } from '@/ui/organisms/usd-amount-tooltip/UsdAmountTooltip'
import { cn } from '@/ui/utils/style'

interface SummaryTileProps {
  title: string
  USDValue: NormalizedNumber
  fancy?: boolean
  'data-testid'?: string
}

export function SummaryTile({ title, USDValue, fancy = false, 'data-testid': dataTestId }: SummaryTileProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center rounded-md bg-primary py-5 md:py-8',
        fancy &&
          'bg-[url(/src/ui/assets/markets/fancy-summary-tile-bg.svg)] bg-cover bg-primary-inverse bg-right bg-no-repeat',
      )}
      data-testid={dataTestId}
    >
      <div className={cn('typography-label-4 text-secondary', fancy && 'text-primary-inverse')}>{title}</div>

      <UsdAmountTooltip
        token={USD_MOCK_TOKEN}
        amount={USDValue}
        style="compact"
        className={cn(
          'typography-heading-3 sm:typography-heading-2 first-letter:typography-heading-4 sm:first-letter:typography-heading-3 relative text-primary',
          fancy && 'bg-linear-to-r from-20% from-[#FF895D] to-80% to-[#FFE6A4] bg-clip-text text-transparent',
        )}
      />
    </div>
  )
}
